var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgets = function SvgWidgets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.727 12.68-4.389-4.388 4.389-4.388 4.363 4.388zm-11.32-2.072v-6.2h6.2v6.2zm8.985 8.984v-6.2h6.2v6.2zm-8.984 0v-6.2h6.2v6.2zm1.3-10.284h3.6v-3.6h-3.6zm10.019 1.534 2.525-2.55-2.525-2.55-2.55 2.55zm-1.035 7.45h3.6v-3.6h-3.6zm-8.984 0h3.6v-3.6h-3.6z"
  })));
};
export default SvgWidgets;